export default "<h1 class=\"header\">{{header}}</h1>\r\n<p>{{summary}}</p>\r\n";